//import LoginPage from "./Pages/Login/Login";
import ContactUsPage from "../Pages/ContactUs/ContactUs";
import DebugPage from "../Pages/Debug/Debug";
import FrontPage from "../Pages/FrontPage/FrontPage";
import NewPictureSetPage from "../Pages/NewPictureSet/NewPictureSet";
import ShoppingCartPage from "../Pages/ShoppingCart/ShoppingCart";
import ShoppingCartEditProductPage from "../Pages/ShoppingCartEditProductPage";
import CheckoutPage from "../Pages/Checkout/Checkout";
import OrderReceiptPage from "../Pages/OrderReceipt/OrderReceipt";
import CreateProductPage from "../Pages/CreateProduct/CreateProduct";
import CategoryProductList from "../Pages/PackageList/Components/CategoryProductList";
import PackageListPage from "../Pages/PackageList/PackageList";
import CreatePackagePage from "../Pages/CreatePackage/CreatePackage";
import MyAccountPage from "../Pages/MyAccount/MyAccount";
import CategoryListPage from "../Pages/CategoryList/CategoryList";

import DigitalPortraitsSubject from "../Pages/DigitalPortraitsSubject/DigitalPortraitsSubject";
import DigitalPortraits from "../Pages/DigitalPortraits/DigitalPortraits";
import TermsAndPolicyPage from "../Pages/TermsPage/TermsPage";
import LegacyPage from "../Pages/LegacyPage";
import ResetPassword from "../Pages/ResetPassword/ResetPassword";
import ShoppingCartRetouch from "@/react/Webshop/Mobile/Pages/ShoppingCartRetouch/ShoppingCartRetouch";
import NewPictureSetFavorites from "@/react/Webshop/Mobile/Pages/NewPictureSetFavorites/NewPictureSetFavorites";
import NewPictureSetYearbookPoseSelection from "@/react/Webshop/Mobile/Pages/NewPictureSetFavorites/NewPictureSetYearbookPoseSelection";

const Routes = {
  debug: {
    path: "/debug",
    component: DebugPage,
    protected: false,
  },
  contactus: {
    path: "/contact-us",
    component: ContactUsPage,
    protected: false,
  },
  privacypolicy: {
    path: "/privacy-policy",
    component: TermsAndPolicyPage,
    protected: false,
  },
  termsofservice: {
    path: "/terms-of-service",
    component: TermsAndPolicyPage,
    protected: false,
  },
  termsofpurchase: {
    path: "/terms-of-purchase",
    component: TermsAndPolicyPage,
    protected: false,
  },
  cookiesdescription: {
    path: "/cookies-description",
    component: TermsAndPolicyPage,
    protected: false,
  },
  myaccount: {
    path: "/my-account",
    component: MyAccountPage,
    protected: true,
    exact: false,
  },
  newpictureset: {
    path: "/new-picture-set",
    component: NewPictureSetPage,
    protected: true,
  },
  "newpictureset.favorites": {
    path: "/new-picture-set/favorites",
    component: NewPictureSetFavorites,
    protected: true,
  },
  "newpictureset.yearbook-pose-section": {
    path: "/new-picture-set/yearbook-pose",
    component: NewPictureSetYearbookPoseSelection,
    protected: true,
  },
  "newpictureset.yearbook-pose-section.job-pose": {
    path: "/new-picture-set/yearbook-pose/:jobPoseUuid",
    component: NewPictureSetYearbookPoseSelection,
    protected: true,
  },
  shoppingcart: {
    path: "/shopping-cart",
    component: ShoppingCartPage,
    protected: true,
  },
  "shoppingcart.edit": {
    path: "/shopping-cart/edit/:uuid",
    component: ShoppingCartEditProductPage,
    protected: true,
  },
  "shoppingcart.retouch": {
    path: "/shopping-cart/retouch",
    component: ShoppingCartRetouch,
    protected: true,
  },
  checkout: {
    path: "/shopping-cart/checkout",
    component: CheckoutPage,
    protected: true,
  },
  /*
    "checkout.payment": {
      path: '/shopping-cart/checkout/payment/:transactionUuid',
      component: PaymentPage,
      protected: true,
    },
     */
  "checkout.receipt": {
    path: "/shopping-cart/checkout/payment/receipt/:orderUuid",
    component: OrderReceiptPage,
    protected: true,
  },
  "products.list": {
    path: "/products/",
    component: CategoryListPage,
    protected: true,
  },
  "products.packages": {
    path: "/products/packages",
    component: PackageListPage,
    protected: true,
  },
  "products.packages.create": {
    path: "/products/packages/:packageUuid",
    component: CreatePackagePage,
    protected: true,
  },
  "products.digitalportraits": {
    path: "/products/digital-portraits",
    component: DigitalPortraits,
    protected: true,
  },
  "products.digitalportraits.subject": {
    path: "/products/digital-portraits/:subjectUuid",
    component: DigitalPortraitsSubject,
    protected: true,
  },
  "products.catalogues": {
    path: "/products/catalogues",
    component: CategoryListPage,
    protected: true,
  },
  "products.categories.category.subcategory": {
    path: "/products/categories/:category/:subCategory?",
    component: CategoryProductList,
    protected: true,
  },
  "products.cards": {
    path: "/products/:type",
    component: CategoryProductList,
    protected: true,
  },
  "products.cards.category": {
    path: "/products/:type/:category",
    component: CategoryProductList,
    protected: true,
  },
  "products.calendars": {
    path: "/products/:type",
    component: CategoryProductList,
    protected: true,
  },
  "products.calendars.pages": {
    path: "/products/:type/?pages=:pages",
    component: CategoryProductList,
    protected: true,
  },
  "products.calendars.create": {
    path: "/products/:type/:productUuid/:templateUuid",
    component: CreateProductPage,
    protected: true,
  },
  "products.photogifts.category": {
    path: "/products/:type/:category",
    component: CategoryProductList,
    protected: true,
  },
  "products.categories.category.subcategory.create": {
    path: "/products/categories/:category/:subCategory/:productUuid/:templateUuid",
    component: CreateProductPage,
    protected: true,
  },
  "products.categories.category.create": {
    path: "/products/:type/:category/:productUuid/:templateUuid",
    component: CreateProductPage,
    protected: true,
  },
  "myaccount.picturesets": {
    component: MyAccountPage,
    path: "/my-account/picture-sets",
  },
  "myaccount.picturesets.pictureset": {
    component: MyAccountPage,
    path: "/my-account/picture-sets/:uuid",
  },
  "myaccount.picturesets.pictureset.favorites": {
    component: MyAccountPage,
    path: "/my-account/picture-sets/:uuid/favorites",
  },
  "myaccount.picturesets.pictureset.yearbookpose": {
    component: MyAccountPage,
    path: "/my-account/picture-sets/:uuid/yearbook-pose",
  },
  "myaccount.picturesets.pictureset.yearbookpose.job-pose": {
    component: MyAccountPage,
    path: "/my-account/picture-sets/:uuid/yearbook-pose/:jobPoseUuid",
  },
  "myaccount.orders": {
    component: MyAccountPage,
    path: "/my-account/orders",
  },
  login: {
    path: "/#login",
    component: FrontPage,
    protected: false,
  },
  addpictureset: {
    path: "/",
    component: FrontPage,
    protected: false,
  },

  frontpage: {
    path: "/",
    component: FrontPage,
    protected: false,
  },
  "pictureset.download.file": {
    path: "/sections/prophoto/ajax/digitalcopies.php?dl=file&file=:uuid",
    protected: true,
    linkComponent: "a",
  },
  "pictureset.download.file.background": {
    path: "/sections/prophoto/ajax/digitalcopies.php?dl=file&file=:uuid&background=:background",
    protected: true,
    linkComponent: "a",
  },
  legacypage: {
    path: "/pages/:id",
    protected: false,
    component: LegacyPage,
  },
  entercode: {
    path: "/",
    component: FrontPage,
    protected: false,
  },
  resetpassword: {
    path: "/reset-password",
    component: ResetPassword,
    protected: false,
  },
};

// We add this as a hook so we can implement localization later:
const useMobileRoutes = () => {
  return Routes;
};

export default useMobileRoutes;
